/**
 * Parslee SSO configuration for the admin dashboard.
 * Login is delegated to the platform (m365dotnet). The dashboard reaches the
 * platform's `/connect/*` endpoints same-origin via the vite dev proxy (local)
 * and the nginx `/connect/` reverse-proxy (prod) added in U3.
 *
 * This constant is the SHARED platform API origin used only by the silent
 * platform-session probe (`probePlatformSession` in lib/auth.ts) so an already
 * signed-in Parslee staffer is bounced into the dashboard login once. It is
 * distinct from the same-origin `/connect/*` proxy the app session uses.
 */
export const PARSLEE_API_URL = import.meta.env.VITE_PARSLEE_API_URL || 'http://localhost:6789';
